import h from 'hyperscript';
import dashboardIcon from '@disy/cadenza-icons/dashboard.svg';

import { createIconButton } from 'ui/button/button';
import { setupMenuButton } from 'ui/menu/menu';

import { createTableExportMenuButton } from 'cadenza/actions/table/create-table-export-menu-actions';
import { icon } from 'cadenza/utils/icon/icon';
import type { TableView } from 'cadenza/map-dashboard/table-view/table-view';
import { CloseTableAction } from 'cadenza/map-dashboard/table-view/actions/close-table-action';
import { ToggleHorizontalLayoutAction } from 'cadenza/map-dashboard/table-view/actions/toggle-horizontal-layout-action';
import { ToggleVerticalLayoutAction } from 'cadenza/map-dashboard/table-view/actions/toggle-vertical-layout-action';

import i18n from './messages.properties';
import './table-view-toolbar.css';

const COMPONENT_NAME = 'd-table-view-toolbar';

export class TableViewToolbar extends HTMLElement {

  constructor () {
    super();
    this.classList.add(COMPONENT_NAME, 'd-legacy-toolbar');
  }

  connectedCallback () {
    const tableView = this.closest<TableView>('d-table-view')!;
    const leftHolder = h('.buttons-container');
    const rightHolder = h('.buttons-container');

    leftHolder.append(this._createTableExportMenuButton(tableView));

    const toggleOrientationDropdown = createIconButton(
      icon(dashboardIcon), i18n('toggleOrientation'), { variant: 'borderless' });
    setupMenuButton(toggleOrientationDropdown, () => [
      new ToggleHorizontalLayoutAction(tableView),
      new ToggleVerticalLayoutAction(tableView)
    ]);

    const closeTableAction = new CloseTableAction();
    const label = typeof closeTableAction.label === 'string' ? closeTableAction.label : closeTableAction.label.textContent ?? '';

    const closeBtn = createIconButton(closeTableAction.icon, label, {
      variant: 'borderless',
      onclick: () => closeTableAction.execute()
    });

    rightHolder.append(toggleOrientationDropdown, closeBtn);
    this.append(leftHolder, rightHolder);
  }

  _createTableExportMenuButton (tableView: TableView) {
    return createTableExportMenuButton(tableView.downloadOptions,
      { searchUrlProvider: () => new URL(tableView.src, window.location.origin).search });
  }

}

customElements.define(COMPONENT_NAME, TableViewToolbar);
